/**
 * OPTIMIZADOR AUTOMÁTICO DE IMÁGENES v1.1
 * Speed Pro Theme
 * 
 * Optimiza todas las imágenes incluyendo:
 * - Shopify CDN
 * - Pexels y otras fuentes externas
 * - GIFs en descripción
 */

(function() {
  'use strict';
  
  // No ejecutar en el editor de Shopify
  if (window.Shopify && window.Shopify.designMode) return;
  
  function optimizeImages() {
    const allImages = document.querySelectorAll('img');
    let lcpOptimized = false;
    
    allImages.forEach((img, index) => {
      const src = img.src || img.getAttribute('data-src') || '';
      if (!src) return;
      
      // Detectar si está en la galería del producto (above the fold)
      const isInGallery = img.closest('.product__media-wrapper') || 
                          img.closest('.product__media-item') ||
                          img.closest('.product__media');
      
      // Detectar si está en la descripción (below the fold)
      const isInDescription = img.closest('.product__description') || 
                              img.closest('.rte') ||
                              img.closest('[class*="description"]');
      
      // Primera imagen de galería: prioridad alta (LCP)
      if (!lcpOptimized && isInGallery && index < 3) {
        img.setAttribute('fetchpriority', 'high');
        img.removeAttribute('loading');
        img.setAttribute('decoding', 'sync');
        lcpOptimized = true;
      } 
      // Imágenes en descripción: SIEMPRE lazy loading
      else if (isInDescription) {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
      }
      // Resto de imágenes después de las primeras 3: lazy loading
      else if (index > 2) {
        if (!img.hasAttribute('loading')) {
          img.setAttribute('loading', 'lazy');
        }
        img.setAttribute('decoding', 'async');
      }
      
      // Optimizar URLs de Shopify CDN con width
      if (src.includes('cdn.shopify.com') && !src.includes('width=')) {
        let width = 800;
        
        // Thumbnails más pequeños
        if (img.classList.contains('pd-thumb') || 
            img.closest('.thumbnail') ||
            img.width < 150) {
          width = 100;
        }
        // Imágenes en descripción más pequeñas
        else if (isInDescription) {
          width = 600;
        }
        
        const separator = src.includes('?') ? '&' : '?';
        img.src = src + separator + 'width=' + width;
      }
      
      // Agregar alt si no tiene
      if (!img.hasAttribute('alt') || img.alt === '') {
        img.setAttribute('alt', 'Producto');
      }
    });
  }
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', optimizeImages);
  } else {
    optimizeImages();
  }
  
})();
